import { Card, CardContent, CardHeader, Grid, TextField } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { EditableField } from '../EditableField/EditableField'
import { CargoSubFormStore } from './CargoSubFormStore'

interface CargoSubFormSectionProps {
  store: CargoSubFormStore
}

export const CargoSubFormSection = observer(({ store }: CargoSubFormSectionProps) => {
  const { t } = useTranslate()
  return (
    <Card variant='outlined'>
      <CardHeader title={t('cargoInformation', 'Cargo information')} />
      <CardContent>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid size={{ xs: 12, md: 4 }}>
            <EditableField
              label={t('cargoStatus', 'Cargo status')}
              dataCy='bulk-edit-cargo-status'
              options={[
                { value: 'Full', label: 'Full' },
                { value: 'Empty', label: 'Empty' },
              ]}
              store={store.cargoStatus}
              disableClear
            />
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <EditableField
              label={t('commodity', 'Commodity')}
              store={store.commodity}
              dataCy='bulk-edit-commodity'
            >
              {(value, onChange) => (
                <TextField
                  label={t('commodity', 'Commodity')}
                  fullWidth
                  value={value ?? ''}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            </EditableField>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
})
